export const UserUserProfilePageHeaderStaffInfoItemName = {
  ExternalId: 'externalId',
  FunctionalRole: 'functionalRole',
  JobPosition: 'jobPosition',
  LastLogin: 'lastLogin',
  Role: 'role',
  SsoId: 'ssoId',
}

export const USER_PROFILE_PAGE_HEADER_STAFF_EDIT_EXTERNAL_ID_FIELD_NAME =
  'external_id'

export const USER_PROFILE_PAGE_HEADER_STAFF_EDIT_EXTERNAL_ID_MODAL_QA_NAME =
  'EditExternalId'

export const USER_PROFILE_PAGE_HEADER_STAFF_EDIT_JOB_POSITION_FIELD_NAME =
  'company_post_name'

export const USER_PROFILE_PAGE_HEADER_STAFF_EDIT_JOB_POSITION_MODAL_QA_NAME =
  'EditJobPosition'

export const USER_PROFILE_PAGE_HEADER_STAFF_EDIT_SSO_ID_FIELD_NAME =
  'sso_external_id'

export const USER_PROFILE_PAGE_HEADER_STAFF_EDIT_SSO_ID_MODAL_QA_NAME =
  'EditSsoId'

export const USER_PROFILE_PAGE_HEADER_STAFF_INFO_ITEMS_LOADING_ITEMS_LENGTH = 6

export const USER_PROFILE_PAGE_HEADER_STAFF_INFO_ITEMS_MAX_ITEMS_IN_ROW = 3

export const USER_PROFILE_PAGE_HEADER_STAFF_TEXT_FIELD_MAX_LENGTH = 255

export const USER_PROFILE_PAGE_HEADER_STAFF_INFO_ITEM_ACTION_QA_NAMES = {
  [UserUserProfilePageHeaderStaffInfoItemName.ExternalId]: {
    add: 'staffProfileHeaderExternalIdAddBtn',
    edit: 'staffProfileHeaderExternalIdEditBtn',
  },
  [UserUserProfilePageHeaderStaffInfoItemName.FunctionalRole]: {
    add: 'staffProfileHeaderFunctionalRoleAddBtn',
    edit: 'staffProfileHeaderFunctionalRoleEditBtn',
  },
  [UserUserProfilePageHeaderStaffInfoItemName.JobPosition]: {
    add: 'staffProfileHeaderJobPositionAddBtn',
    edit: 'staffProfileHeaderJobPositionEditBtn',
  },
  [UserUserProfilePageHeaderStaffInfoItemName.Role]: {
    edit: 'staffProfileHeaderRoleEditBtn',
  },
  [UserUserProfilePageHeaderStaffInfoItemName.SsoId]: {
    add: 'staffProfileHeaderSsoIdAddBtn',
    edit: 'staffProfileHeaderSsoIdEditBtn',
  },
}
